<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>Das Objekt befindet sich in der Gemeinde Herschbach in Rheinland-Pfalz. Das Sportlerheim wurde für den Sportverein HSV 21 entworfen. Der experimentelle Charakter des Objektes deutet auf die bauliche Konzeption aber auch den damit einhergehenden Beitrag zur Dorfentwicklung hin. Vom Gebäude geht ein wichtiger Impuls für den Sportverein, die Ortsgemeinde sowie Entwicklung und Leben im ländlichen Bereich aus. Das Objekt wurde von der Europäischen Union aus dem Europäischen Fonds für regionale Entwicklung EFRE kofinanziert. </p>

            <p>Es handelt sich um ein partizipatives Konzept, welches gemeinsam mit dem Sportverein Herschbach entwickelt wurde. An der Realisierung waren die Mitglieder des Sportvereins und viele ehrenamtliche Helfer aus der Gemeinde beteiligt. Regionale Unternehmen und Energieversorger beteiligten sich ebenfalls an der Umsetzung. </p>

            <p>Im Bereich der nicht erneuerbaren Werkstoffe kommen wiederverwertete Produkte und Halbzeuge zum Einsatz (Fortführung der Recyclingkette). Die Materialien werden konstruktiv so gefügt, dass diese in die Einzelfraktionen zurück gebaut und weiterverwendet werden können. Insbesondere die Kombination verschiedener Materialien mit ökologischen Technologien zeigt neue Wege auf und wird im Experimentalbau durch ein grünes Band, welches Gründach und Grünfassaden integriert, zeichenhaft umgesetzt. Der hybride Gebäudeaufbau verbindet eine Holz-Tragstruktur mit einer Fassade aus recyceltem Aluminium und bepflanzten Fassaden- und Dachbereichen. Die Wasserzufuhr der Grünfassaden erfolgt über ein sensorgesteuertes Bewässerungssystem. Die große Offenheit und der damit einhergehende Mut zum "Gestalterischen Wagnis" eröffnen dem zeitgenössischen Bauen auf dem Land völlig neue Gestaltungsperspektiven. Das Sportlerheim hat sich sich in den letzten 10 Jahren zu einem lebendigen Ort für unterschiedliche Generationen entwickelt.</p>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf</p>
            <p>Markus Holzbach</p>
        </span>

    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/_DSC1287.jpg' ),
                require( '@/assets/img/pc/3 Innenaufnahme HSV.jpg' ),
                require( '@/assets/img/pc/3_02.jpg' ),
                require( '@/assets/img/pc/CIMG6685.jpg' ),
                require( '@/assets/img/pc/HSV21 Holzbach Bild 8.jpg' ),
                require( '@/assets/img/pc/_DSC1314.jpg' ),
                require( '@/assets/img/pc/HSV21 Holzbach Innenraum Korridor Bild 5.jpg' ),
                require( '@/assets/img/pc/HSV21 Holzbach Bild 2.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>